import React, { useEffect } from "react";

import Main from '../components/Sponsorship/Main'
import Swiper from "../components/Sponsorship/Swiper";

function Sponsorship () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <Swiper/>
        </div>
    );
}

export default Sponsorship;